export default __webpack_public_path__ + "static/media/upload.61baf41e.svg";